export default __webpack_public_path__ + "static/media/edit.78e6abe4.svg";